import { LoadingButton } from '@mui/lab';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Skeleton,
    TextField,
    Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteIcon } from 'src/components/therapyPlanning_2.0/commonComponent/therapy-planning-icons';
import { permissions } from 'src/paths';
import {
    createTherapistTaskNoteAction,
    resetGetTherapistTaskNote,
} from 'src/redux/actions/therapySchedulingSkillList';

const { UPDATE_DAILY_TASK } = permissions;

type Props = {
    handleCloseTaskNote: any;
    currentPatientTask: any;
    isEditNote: any
    handleOpenDeleteTaskNote: any
};

function ScheduleTaskNote(props: Props) {
    const { handleCloseTaskNote, currentPatientTask, isEditNote, handleOpenDeleteTaskNote } = props;
    const getTaskNote = useSelector((state: any) => state.getTherapistTaskNoteReducer);
    const isTaskNoteCreated = useSelector((state: any) => state.createTherapistTaskNoteReducer)

    const providerId = useSelector(
        (state: any) => state?.getTherapistProfileReducer?.response?.data?.providerId
    );
    const dispatch = useDispatch();
    const [taskNote, setTaskNote] = useState('');
    const maxLength = 1024;


    useEffect(() => {
        if (!getTaskNote?.isGetTaskNote && getTaskNote?.response === null) return;
        if (!getTaskNote?.isGetTaskNote && getTaskNote?.response !== null) {
            dispatch(resetGetTherapistTaskNote());
            return;
        }
        setTaskNote(getTaskNote?.response?.data?.taskNote ? getTaskNote?.response?.data?.taskNote : '');
        dispatch(resetGetTherapistTaskNote());
        return;
    }, [getTaskNote]);

    const saveNoteOfTask = () => {
        dispatch(
            createTherapistTaskNoteAction({
                providerId: providerId,
                taskId: currentPatientTask,
                data: {
                    taskNote: taskNote,
                },
            })
        );
    };

    return (
        <Grid
            width={600}
            container
            flexDirection={'column'}
            gap={'20px'}
        >
            <DialogTitle
                sx={{ m: 0, p: 3 }}
                id="customized-dialog-title"
            >
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 600,
                        lineHeight: 1.4,
                    }}
                >
                    {isEditNote ? 'Edit a note' : 'Add a note'}
                </Typography>
            </DialogTitle>
            <DialogContent
                sx={{
                    paddingBottom: '0px !important',
                }}
            >
                {getTaskNote?.loader ? (
                    <Stack spacing={1}>
                        <Skeleton
                            variant="rectangular"
                            height={85}
                        />
                    </Stack>
                ) : (
                    <TextField
                        fullWidth
                        label="DOR Note"
                        name="taskNote"
                        value={taskNote}
                        multiline
                        onChange={(e) => setTaskNote(e.target.value)}
                        rows={3}
                            error={taskNote?.length > maxLength}
                            helperText={
                                taskNote?.length > maxLength
                                    ? `The input exceeds the maximum character limit of ${maxLength}. Please reduce the text length.`
                                    : ""
                            }
                    />
                )}
            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: 4,
                    mb: 2,
                }}
            >
                <Stack>
                    <IconButton
                        sx={{
                            borderRadius: '11.765px',
                            background: '#FEE4E2',
                            ml: 2,
                            '&:hover': {
                                borderRadius: '11.765px',
                                background: '#FEE4E2',
                            },
                        }}
                        onClick={handleOpenDeleteTaskNote}
                        disabled={getTaskNote?.loader}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Stack>
                <Stack
                    flexDirection={'row'}
                    gap={2}
                >
                    <Button
                        autoFocus
                        onClick={handleCloseTaskNote}
                        disabled={getTaskNote?.loader}
                    >
                        Cancel
                    </Button>

                    <LoadingButton
                        variant="contained"
                        autoFocus
                        type="submit"
                        disabled={!taskNote || getTaskNote?.loader || taskNote?.length > maxLength}
                        onClick={saveNoteOfTask}
                        sx={{
                            whiteSpace: 'nowrap',
                            // height: 5,
                            width: 120,
                            ':hover': {
                                background: '#6366F1',
                            },
                            '.MuiLoadingButton-loadingIndicator': {
                                left: 15,
                            },
                        }}
                        loadingPosition="start"
                        loading={isTaskNoteCreated?.loader}
                    >
                        Save
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Grid>
    );
}

export default ScheduleTaskNote;
